import { startMixpanelRecording } from "common/utils/mixpanel/tracker";

const HOTJAR_PINNING_EVENT = "design_lab_pinning_mode_entered";

let recordingStarted = false;

type StartPinSessionRecordingParams = {
  enabled: boolean;
  forceMixpanelRecording?: boolean;
};

export function startPinSessionRecording({
  enabled,
  forceMixpanelRecording = false
}: StartPinSessionRecordingParams): boolean {
  if (!enabled || recordingStarted) return false;

  recordingStarted = true;

  startMixpanelRecording(100, { force: forceMixpanelRecording });

  // Fire Hotjar event if Hotjar is available
  // Hotjar script is now loaded at page load, so we just need to fire the event
  function fireHotjarEvent() {
    const { hj: hotjar } = window as Window & { hj?: (...args: unknown[]) => void };
    if (typeof hotjar === "function") {
      hotjar("event", HOTJAR_PINNING_EVENT);
    } else {
      // Retry if Hotjar isn't ready yet (should be rare since it loads at page load)
      let retryCount = 0;
      const maxRetries = 50; // 5 seconds max (50 * 100ms)
      const checkHotjar = () => {
        const { hj } = window as Window & { hj?: (...args: unknown[]) => void };
        if (typeof hj === "function") {
          hj("event", HOTJAR_PINNING_EVENT);
        } else if (retryCount < maxRetries) {
          retryCount += 1;
          setTimeout(checkHotjar, 100);
        } else {
          // eslint-disable-next-line no-console
          console.warn("Hotjar not available after maximum retries");
        }
      };
      setTimeout(checkHotjar, 100);
    }
  }

  fireHotjarEvent();

  return true;
}
